<template>
  <div id="subpage" v-loading="loading">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>首页</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>阿里云设置</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <span class="title">阿里云设置</span>
      </div>
      <div class="xcx-content">
        <el-form
          ref="form_data"
          :model="form_data"
          :rules="rules"
          label-width="160px"
          style="width: 80%"
        >
          <el-form-item label="ACCESS_ID：" prop="OSS_ACCESS_ID">
            <el-input
              v-model="form_data.OSS_ACCESS_ID"
              placeholder="请输入阿里云ACCESS_ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="ACCESS_KEY：" prop="OSS_ACCESS_KEY">
            <el-input
              v-model="form_data.OSS_ACCESS_KEY"
              placeholder="请输入阿里云ACCESS_KEY"
            ></el-input>
          </el-form-item>
          <el-form-item label="OSS_BUCKET：" prop="OSS_BUCKET">
            <el-input
              v-model="form_data.OSS_BUCKET"
              placeholder="请输入阿里云OSS_BUCKET"
            ></el-input>
          </el-form-item>
          <el-form-item label="OSS_ENDPOINT：" prop="OSS_ENDPOINT">
            <el-input
              v-model="form_data.OSS_ENDPOINT"
              placeholder="请输入阿里云OSS_ENDPOINT"
            ></el-input>
          </el-form-item>
          <el-form-item label="绑定域名：" prop="OSS_MYDOMAIN">
            <el-input
              v-model="form_data.OSS_MYDOMAIN"
              placeholder="请输入阿里云OSS绑定域名"
            ></el-input>
          </el-form-item>
          <el-form-item class="mar_T_50">
            <el-button type="primary" @click="save()">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      form_data: {
        OSS_ACCESS_ID: "",
        OSS_ACCESS_KEY: "",
        OSS_BUCKET: "",
        OSS_ENDPOINT: "",
        OSS_MYDOMAIN: "",
      },
      postData: [],
      id: "",
      rules: {
        OSS_ACCESS_ID: [
          { required: true, message: "请输入阿里云ACCESS_ID", trigger: "blur" },
        ],
        OSS_ACCESS_KEY: [
          {
            required: true,
            message: "请输入阿里云ACCESS_KEY",
            trigger: "blur",
          },
        ],
        OSS_BUCKET: [
          {
            required: true,
            message: "请输入阿里云OSS_BUCKET",
            trigger: "blur",
          },
        ],
        OSS_ENDPOINT: [
          {
            required: true,
            message: "请输入阿里云OSS_ENDPOINT",
            trigger: "blur",
          },
        ],
        OSS_MYDOMAIN: [
          {
            required: true,
            message: "请输入阿里云OSS绑定域名",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    var that = this;
    that.getDetail();
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      var that = this;
      that.axios.post("/Config/getOss").then((res) => {
        if (res) {
          that.form_data = res.data;
        }
        that.loading = false;
      });
    },
    save() {
      const that = this;
      that.$refs.form_data.validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.form_data;
        var url = "/Config/oss";
        that.axios.post(url, formData).then(() => {
          that.$message.success("保存成功");
          that.$router.push("/Config/oss");
        });
      });
    },
  },
};
</script>
